import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Ul, AttributeItem } from "components/lists";
import { formatDate } from "utils/dates";
import { updatePatient } from "actions/patient";
import { InlineWaiting } from "components/ui";

const ResupplyDate = ({ patientInfo, patientId, readOnly }) => {
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = React.useState(false);
  return (
    <div>
      <h3
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          fontSize: "1.4em",
          textTransform: "uppercase"
        }}
      >
        Resupply
      </h3>
      <Ul>
        <AttributeItem title="Outreach Date">
          {formatDate(patientInfo.outreach_date, "MM/DD/YYYY")}
        </AttributeItem>
        <AttributeItem title="Outreach Cycle">
          {patientInfo.outreach_cycle_count}
        </AttributeItem>
        <AttributeItem title="Override Outreach Date:">
          <div className="overide-date-checkbox-container">
            {isUpdating ? (
              <InlineWaiting />
            ) : (
              <input
                type="checkbox"
                checked={patientInfo.overrideEligibilityDate || false}
                style={{ margin: "5px 0px 0px 20px", cursor: "pointer" }}
                disabled={!patientInfo.active || readOnly}
                onChange={async ({ target: { checked } }) => {
                  setIsUpdating(true);
                  await dispatch(
                    updatePatient({
                      patientId,
                      updates: {
                        overrideEligibilityDate: checked
                      }
                    })
                  );
                  setIsUpdating(false);
                }}
              />
            )}
          </div>
        </AttributeItem>
      </Ul>
    </div>
  );
};

ResupplyDate.propTypes = {
  patientInfo: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  patientId: PropTypes.string
};

export default ResupplyDate;
